import styled, { css } from 'styled-components';
import { Button as ButtonComponent } from 'src/components';

export const Container = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: row;
    align-items: baseline;
    justify-content: space-between;

    @media (max-width: ${theme.sz.md}) {
      flex-direction: column;
      align-items: flex-start;
    }
  `,
);

export const OptionsWrapper = styled.div(
  ({ theme }) => css`
    background: ${theme.co.neutral98};
    display: flex;
    flex-wrap: wrap;
    border-radius: ${theme.sz.s4};
  `,
);

export const Title = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.base};
  `,
);

export const ButtonWrapper = styled.div<{ $isSelected: boolean }>(
  ({ theme, $isSelected }) => css`
    min-width: ${theme.sz.s16};
    height: ${theme.sz.s12};
    margin: ${theme.sz.s2};
    border-radius: ${theme.sz.s4};
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: ${theme.sz.md}) {
      min-width: ${theme.sz.s12};
      height: ${theme.sz.s8};
      margin: ${theme.sz.s05};
      border-radius: ${theme.sz.s3};
    }

    ${$isSelected &&
    css`
      box-shadow: 0 ${theme.sz.s05} ${theme.sz.s1} ${theme.co.neutral90};
      background: ${theme.co.neutral99};
    `}
  `,
);

export const Button = styled(ButtonComponent)(
  ({ theme }) => css`
    width: 100%;
    height: 100%;
    border-radius: ${theme.sz.s4};
    padding: 0;

    @media (max-width: ${theme.sz.md}) {
      border-radius: ${theme.sz.s3};
    }
  `,
);

export const Option = styled.div(
  () => css`
    display: flex;
    align-items: center;
    flex-direction: row;
  `,
);

export const Divider = styled.div(
  ({ theme }) => css`
    border-right: ${theme.bo.thinWidth} solid ${theme.co.neutral99};
    height: 60%;
  `,
);
